<template>
    <div>
        <div class='autocomplete2-container'>
            <label class="labelText" for="address">Adresse: *</label>
            <input type="text" name="prevent_autofill" id="prevent_autofill" value="" style="display:none;" />
            <input type="text" name="textfake" id="textfake" value="" style="display:none;" />
            <input 
                @input="InputChanged" 
                class="imputText" 
                type="text" 
                ref="address" 
                @blur="hideSelectList(); $emit('check');"
                @keydown="
                    e => {
                        keyDownHandler(e);
                    }
                "
            />

        </div>
        <div v-show="selectListVisible" class="autocomplete2-container">
        <ul
            class="dawa-autocomplete-suggestions"
            style="margin: 1em, 0, 0, 0em; overflow;"
        >
            <li
            v-for="(item, i) in items"
            :key="i"
            :class="
                i === selectedItem
                ? 'dawa-autocomplete-suggestion dawa-selected'
                : 'dawa-autocomplete-suggestion'
            "
            @mousedown="selectAddress(item)"
            >
                {{ item.tekst }}
            </li>
        </ul>
        </div>
        <div class="invalid" v-if="error">
            {{errorMessage}}
        </div>
    </div>

</template>

<script>
    import { DawaService } from "../../services/DawaService";
    export default{
        props: [
            'errorMessage',
            'error'
        ],
        mounted() {
            this.$emit("rendered");
            this.clearItems();
            this.resetAutoCompleteType();
        },
        data: () => ({
            selectListVisible: false,
            items: [],
            selectedItem: 0,
            autoCompleteType: ""
        }),
        methods: {
            clearItems() {
                this.items = [];
                this.selectedItem = 0;                
            },
            resetAutoCompleteType()
            {
                this.autoCompleteType = this.selectAutoCompleteType();
            },
            hideSelectList()
            {
                this.selectListVisible = false;
            },
            showSelectList()
            {
                this.selectListVisible = true;
            },
            InputChanged(e) {
                var val = e.target.value;

                this.autoComplete(val, this.autoCompleteType);
                this.$emit("dawa", val);
            },
            autoComplete(val, autoCompleteType)
            {                
                if (!val) 
                {
                    this.clearItems();
                    this.resetAutoCompleteType();
                    return;
                }
                
                if (this.isLoading) {
                    this.rerunWhenFinished = true;
                    return;
                }

                clearTimeout(this._timerId);

                // delay new call 200ms
                this._timerId = setTimeout(() => {
                    this.isLoading = true;

                    DawaService.addressLookup(val, autoCompleteType)
                        .then(
                            response => {
                                if (response) {                                    
                                    this.items = response.slice(0, 100);
                                    this.showSelectList();
                                }
                            },
                            error => {
                                console.error(error);
                            }                            
                        )
                        .finally(() => {
                            this.isLoading = false;
                            if (this.rerunWhenFinished) {
                                this.autoComplete(val, autoCompleteType);
                                this.rerunWhenFinished = false;
                            }
                        });
                }, 200);
            },
            selectAddress(selected) {
                if (selected) {
                    this.$refs.address.value = selected.tekst;
                    this.autoCompleteType = this.selectAutoCompleteType(selected.type);

                    if(selected.type == "adresse")
                    {
                        this.$emit("selected", selected.data);                        
                    } 
                    else {
                        this.$refs.address.value = `${selected.tekst} `;
                        this.autoComplete(this.$refs.address.value, this.autoCompleteType);
                    }                    
                }
                this.clearItems();
            },
            selectAutoCompleteType(base){
                switch(base){
                    case "adresse":
                    case "adgangsadresse": return "adresse";
                    case "husnummer": return "adresse";
                    case "vejnavn": return "adresse";
                    default: return "vejnavn";                    
                }
            },
            keyDownHandler(e) {                
                if (e && !this.selectListVisible) {
                    const key = window.event ? e.keyCode : e.which;
                    // down (40)
                    if (key === 40) {      
                        this.showSelectList();
                    }
                }
                else if (e && this.items && this.items.length > 0) {
                    const key = window.event ? e.keyCode : e.which;
                    // down (40)
                    if (key === 40) {      
                        this.selectedItem = (this.selectedItem + 1) % this.items.length;
                    }
                    //up (38)
                    else if (key === 38) {
                        this.selectedItem = (this.selectedItem - 1 + this.items.length) % this.items.length;
                    }
                    // enter or tab
                    else if (key === 13 || key === 9) {
                        this.selectAddress(this.items[this.selectedItem]);
                        e.preventDefault();
                    }
                    // esc
                    else if (key === 27) {
                        this.hideSelectList();
                        // this.clearItems();
                        // this.resetAutoCompleteType();
                    }
                    // backspace
                    else if (key === 8) {                        
                        this.clearItems();
                        this.resetAutoCompleteType();
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .labelText{
        font-family: "Newson", Verdana, sans-serif;
        color:gray
    }
    .invalid {
        color: red;
        font-size: 12px;
        margin-top: 3px;
    }
    .imputText{
        background-image: none;
        background-color: transparent;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 6px;
        border: 1px solid #231F20;
        padding: 7px;
        width: 100%;
        line-height: 1;
        font-size: 13px;
        font-family: Arial;
    }
    .autocomplete2-container {
        /* relative position for at de absolut positionerede forslag får korrekt placering.*/
        position: relative;
        width: 100%;
        max-width: 40em;
    }
    .autocomplete2-container input {
        /* Både input og forslag får samme bredde som omkringliggende DIV */
        width: 100%;
        box-sizing: border-box;
    }
    .dawa-autocomplete-suggestions {
        margin: 0.3em 0 0 0;
        padding: 0;
        text-align: left;
        border-radius: 0.3125em;
        background: #fcfcfc;
        box-shadow: 0 0.0625em 0.15625em rgba(0,0,0,.15);
        position: absolute;
        left: 0;
        right: 0;
        z-index: 9999;
        overflow-y: auto;
        box-sizing: border-box;
    }
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
        margin: 0;
        list-style: none;
        cursor: pointer;
        padding: 0.4em 0.6em;
        color: #333;
        border: 0.0625em solid #ddd;
        border-bottom-width: 0;
    }
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
        border-bottom-width: 0.0625em;
    }
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
        background: #f0f0f0;
    }
</style>